export enum BackLinkType {
  Back = "BACK",
  Close = "CLOSE",
}
